"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = void 0;
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
exports.isSafari = isSafari;
//# sourceMappingURL=isSafari.js.map